import { AxiosError } from 'axios'

import type { RequestError } from './types'
import { getErrorMessage, isRequestError } from './utils'

export const ERR_UNKNOWN = 'ERR_UNKNOWN'
export const ERR_REQUEST_INTERCEPTOR = 'ERR_REQUEST_INTERCEPTOR'
export const ERR_RESPONSE_INTERCEPTOR = 'ERR_RESPONSE_INTERCEPTOR'

export interface ErrorCodes {
  ERR_UNKNOWN: typeof ERR_UNKNOWN
  ERR_REQUEST_INTERCEPTOR: typeof ERR_REQUEST_INTERCEPTOR
  ERR_RESPONSE_INTERCEPTOR: typeof ERR_RESPONSE_INTERCEPTOR
}

const InternalError = AxiosError as typeof AxiosError & ErrorCodes

InternalError.ERR_UNKNOWN = 'ERR_UNKNOWN'
InternalError.ERR_REQUEST_INTERCEPTOR = 'ERR_REQUEST_INTERCEPTOR'
InternalError.ERR_RESPONSE_INTERCEPTOR = 'ERR_RESPONSE_INTERCEPTOR'

const DefaultMessages = {
  [ERR_UNKNOWN]: 'An unknown error occurred',
  [ERR_REQUEST_INTERCEPTOR]: 'Request interceptor error',
  [ERR_RESPONSE_INTERCEPTOR]: 'Response interceptor error',
}

export type RequestErrorCode =
  | typeof ERR_UNKNOWN
  | typeof ERR_REQUEST_INTERCEPTOR
  | typeof ERR_RESPONSE_INTERCEPTOR

export function createRequestError(
  errOrMessage: any,
  extra: Pick<RequestError, 'config' | 'request' | 'response'>,
  code: RequestErrorCode = 'ERR_UNKNOWN',
): RequestError {
  if (isRequestError(errOrMessage)) return errOrMessage

  const cause = errOrMessage.message
    ? errOrMessage
    : { message: getErrorMessage(errOrMessage, DefaultMessages[code]) }

  return InternalError.from(
    cause,
    code,
    extra?.config,
    extra?.request,
    extra?.response,
  ) as RequestError
}
